import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";
import { OrderManagementSuiteStatusesContext } from "../../../../redo-suite/order-management-cloud";

export const AnalyticsItem = memo(function AnalyticsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const { returnsEnabled, packageProtectionEnabled } = useContext(
    OrderManagementSuiteStatusesContext,
  );

  const hasPermissionToViewOrderFulfillment = useHasPermission(
    OrderManagementPermissions.VIEW_ORDER_FULFILLMENT_ANALYTICS,
  );
  const hasPermissionToViewReturnsClaims = useHasPermission(
    OrderManagementPermissions.VIEW_RETURN_AND_CLAIM_ANALYTICS,
  );

  const showReturnsClaims =
    (returnsEnabled || packageProtectionEnabled) &&
    hasPermissionToViewReturnsClaims;

  const orderFulfillmentUrlPrefix = routes.analyticsOrderFulfillmentHref;
  const returnsClaimsUrlPrefix = routes.analyticsReturnsClaimsHref;

  const orderFulfillmentSelected = useMatch(`${orderFulfillmentUrlPrefix}/*`);
  const returnsClaimsSelected = useMatch(`${returnsClaimsUrlPrefix}/*`);
  const anyChildSelected = orderFulfillmentSelected || returnsClaimsSelected;

  const shouldShowAnalytics =
    hasPermissionToViewOrderFulfillment || showReturnsClaims;

  if (!shouldShowAnalytics) {
    return null;
  }

  const defaultRoute = hasPermissionToViewOrderFulfillment
    ? routes.analyticsOrderFulfillmentHref
    : routes.analyticsReturnsClaimsHref;

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: defaultRoute }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={BarChart10FilledIcon}
      friendlyName="Analytics"
      id="analytics"
      UnfilledIcon={BarChart10Icon}
    >
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.analyticsOrderFulfillmentHref }}
        friendlyName="Order fulfillment"
        hidden={!hasPermissionToViewOrderFulfillment}
        id="analytics-order-fulfillment"
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.analyticsReturnsClaimsHref }}
        friendlyName="Returns & claims"
        hidden={!showReturnsClaims}
        id="analytics-returns-claims"
      />
    </RedoSecondaryNavItem>
  );
});
